const ipAddress = 'https://memoryapp.komorowskiprzemyslaw.pl'
export {ipAddress}